import { useRouter } from 'next/router';
import {
  Channel,
  getSegmentData,
  Segment,
  UseSegmentReturn,
} from '@sparknz/journeys-common';

export type { Channel, Segment };

export function useSegment(): UseSegmentReturn {
  const { pathname } = useRouter();

  return getSegmentData(pathname);
}
